import { render, staticRenderFns } from "./actualitiesReglementation.vue?vue&type=template&id=07b1b11e&scoped=true"
import script from "./actualitiesReglementation.vue?vue&type=script&lang=js"
export * from "./actualitiesReglementation.vue?vue&type=script&lang=js"
import style0 from "./actualitiesReglementation.vue?vue&type=style&index=0&id=07b1b11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b1b11e",
  null
  
)

export default component.exports